// extracted by mini-css-extract-plugin
module.exports = {"infoValueContainer":"u1","color":"u2","circle":"u3"};